import React, { useEffect } from 'react';
import './userProfile.css';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../rtk/thunks/authThunk';

const UserProfile = () => {
  const dispatch = useDispatch();
  const { user, loading, error, message, access_token } = useSelector((state) => state.auth);

  // prefer token from redux, fallback to localStorage
  const accessToken = access_token || localStorage.getItem('access_token');

  
  useEffect(() => {
    if (!accessToken) return; // don't fetch if not authenticated
    dispatch(getProfile()).catch(() => {});
  }, [dispatch, accessToken]);

  const formatValue = (v) => (v === null || v === undefined || v === '' ? '—' : v);

  const formatError = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.filter(Boolean).join(' ');
    return (
      value.detail ||
      value.message ||
      Object.values(value)
        .flat()
        .find((item) => typeof item === 'string' && item.trim()) ||
      JSON.stringify(value)
    );
  };

  return (
    <div className="user-profile-page">
      <div className="user-profile-card">
        <div className="user-profile-header">
          <p className="user-profile-eyebrow">Your account</p>
          <h2>User Profile</h2>
          <p className="user-profile-subtitle">User details</p>
        </div>

        <div className="user-profile-form">
          {loading && <p>Loading...</p>}
          {error && <p className="form-error">{formatError(error)}</p>}
          {message && <p className="form-success">{message}</p>}

          <div className="user-profile-grid">
            <div className="profile-item">
              <p className="profile-label">First name</p>
              <p className="profile-value">{formatValue(user?.first_name)}</p>
            </div>
            <div className="profile-item">
              <p className="profile-label">Last name</p>
              <p className="profile-value">{formatValue(user?.last_name)}</p>
            </div>
          </div>

          <div className="profile-item profile-item-full">
            <p className="profile-label">Email</p>
            <p className="profile-value">{formatValue(user?.email)}</p>
          </div>

          <div className="user-profile-grid">
            <div className="profile-item">
              <p className="profile-label">Phone</p>
              <p className="profile-value">{formatValue(user?.phone)}</p>
            </div>
            <div className="profile-item">
              <p className="profile-label">Country</p>
              <p className="profile-value">{formatValue(user?.country)}</p>
            </div>
          </div>

          <div className="profile-item profile-item-full">
            <p className="profile-label">Weekly study hours</p>
            <p className="profile-value">{formatValue(user?.weekly_study_hours)}</p>
          </div>

          <p className="form-note">To update your profile, go to Account Settings.</p>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
